var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navigation',{attrs:{"rims-config":""}}),_c('v-main',{staticClass:"rims-config__layout"},[_c('transition',{attrs:{"name":"page"}},[_vm._t("default")],2)],1),_c('footer-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }